import React, { useEffect, useState } from 'react'
import { Earnings, Point, PurchaseAmount, RedeemAmount, Redeeming, RewardCharge, Save } from '../../../Constant'
import { Card, CardBody, CardHeader, Col, Form, FormGroup, Label, Row } from 'reactstrap'
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { addRewardRate, addRewardRateRole, viewReward, viewRewardRole } from '../../../CommonUrl';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Btn, H3 } from '../../../AbstractElements';

const AmountRatio = () => {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
        const authState = useSelector((state) => state.auth);
        const [loading, setLoading] = useState(false);
        const navigate = useNavigate();
        const isReadOnly = authState.userRole !== 1;
    
        useEffect(() => {
            getDeliveryData();
        }, []);
    
        const getDeliveryData = async () => {
            setLoading(true);
            const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewReward : viewRewardRole);
            if (data.status === true) {
                setValue('purchaseAmount', data?.data?.purchase_amount);
                setValue('point', data?.data?.redeem_points);
            } else if (data.status >= 400 && data.status <= 405) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
            } else if (data.status >= 500 && data.status <= 505) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
            } else {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
            }
            setLoading(false);
        }
    
    
        const onSubmit = async (data) => {
            setLoading(true);
            const postRequest = {
                redeem_points: data?.point, purchase_amount: data?.purchaseAmount,
            }
            const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? addRewardRate : addRewardRateRole, postRequest);
            if (addAreaResponse.status === 200) {
                if (addAreaResponse.data.status === true) {
                    toast.success(addAreaResponse.data.message);
                } else {
                    toast.error(addAreaResponse.data.message)
                    setLoading(false);
                }
            } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
            } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
            } else {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
            }
            setLoading(false);
        };
    return (
        <Card>
            <CardHeader className="pb-0">
                <H3>{RewardCharge}</H3>
            </CardHeader>
            <CardBody>
                <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Row className="g-3 pt-3">
                        <h4>{Earnings}</h4>
                        <Col md='6'>
                            <Label className="form-label" for="purchase-amount">{PurchaseAmount}</Label>
                            <input className="form-control" id="purchase-amount" type="text" readOnly={isReadOnly} {...register('purchaseAmount')} />
                            <span className="text-danger">{errors.quickDelivery && AreaNameError}</span>
                        </Col>
                        <Col md="6">
                            <Label className="form-label" for="earn-point">{Point}</Label>
                            <input className="form-control" id="earn-point" type="text" defaultValue="1" readOnly />
                        </Col>
                    </Row>
                    <Row className="g-3 pt-3">
                        <h4>{Redeeming}</h4>
                        <Col md='6'>
                            <Label className="form-label" for="point">{Point}</Label>
                            <input className="form-control" id="point" type="text" readOnly={isReadOnly} {...register('point')} />
                            <span className="text-danger">{errors.normalDel && AreaNameError}</span>
                        </Col>
                        <Col md="6">
                            <Label className="form-label" for="redeem_amount">{RedeemAmount}</Label>
                            <input className="form-control" id="redeem_amount" type="text" defaultValue="1" readOnly />
                        </Col>
                    </Row>
                    <FormGroup>
                    </FormGroup>
                    <Btn attrBtn={{ color: "primary", disabled: isReadOnly }} type="submit">{Save}</Btn>
                </Form>
            </CardBody>
        </Card>
    )
}

export default AmountRatio